// Module
var code = "<div class=\"chart-wrapper\" data-bind=\"attr: {id: _wrapperId}, click: _help.ShowControlHelp.bind(_help, $data)\"> </div>";
// Exports
export default code;